<template>
  <div>
    <!-- empty Data component -->
    <empty-data v-if="emptyDataFlag" v-bind:text="emptyDataText"></empty-data>

    <!-- 신청서 리스트 -->
    <v-list v-else flat class="doc-list">
      <v-list-item-group>
        <v-list-item
          v-for="item in searchList"
          :key="item.applSeq"
          @click="openViewer(item)"
          class="doc-list-divider"
          :class="item.cancleApplYn === 'N'?'disabled':''"
        >
          <v-list-item-icon class="avatar-wrap">
            <v-avatar size="52" class="with-icon bg-grey">
              <!-- 신청서에 따라 아이콘 변경 -->
              <appl-menu-icon
                :propsParam="{
                  applCd: item.applCd,
                  gntGubunCd: item.gubunCd,
                }"
                :styleClassStr="'mr-0'"
              ></appl-menu-icon>
            </v-avatar>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="doc-title">{{
              item.title
            }}</v-list-item-title>
            <v-list-item-subtitle class="date">
              <span> {{ item.useYmd }} </span>
            </v-list-item-subtitle>
            <!-- 개발중 -->
            <v-list-item-subtitle class="draft-wrap">
              <span class="draft">기안일</span>
              <span class="date">
                {{ item.applYmdFormat }}
              </span>
            </v-list-item-subtitle>
            <v-list-item-subtitle class="draft-wrap">
              <span class="draft">휴일대체</span>
              <span class="date">
                {{ item.workYmd }}
              </span>
            </v-list-item-subtitle>
            <v-list-item-subtitle class="draft-wrap">
              <span class="draft">평일대체</span>
              <span class="date">
                {{ item.replaceYmd }}
              </span>
            </v-list-item-subtitle>
            <!--
            <v-list-item-subtitle class="draft-wrap">
              <span class="draft">{{ item.applTypeCdNm }}</span>
              <span class="draft">{{ item.mobileYn }}</span>
            </v-list-item-subtitle>
            -->
          </v-list-item-content>
          <v-list-item-icon class="align-self-center">
            <v-chip
              class="step"
              :class="stepChipClass(item.applStatusCd)"
              v-show="searchReqGubun != 'TEMP'"
              v-text="item.applStatusNm"
            ></v-chip>
          </v-list-item-icon>
          <v-list-item-icon class="align-self-center ml-1">
            <v-btn fab text width="24" height="24" color="grey">
              <v-icon size="24">mdi-chevron-right</v-icon>
            </v-btn>
          </v-list-item-icon>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
/* 내 신청서 리스트 컴포넌트 */
import EmptyData from '@/components/common/EmptyData.vue';
import ApplMenuIcon from '@/components/application/form/ApplMenuIcon.vue';

import dayjs from 'dayjs';
import messageConstants from '@/const/messageConstants.js';
import { holReplaceCancelBoxList } from '@/api/allDoc.js';
import { mapGetters } from 'vuex';
import routerNames from '@/const/routerConstants';
import { getFileSeq } from '@/api/approvalCommon';

export default {
  props: {
    // 조회요청구분 (MYDOC:내문서, TEMP:임시저장문서, CANCEL:취소신청문서)
    searchReqGubun: {
      type: String,
    },
    // 조회신청서코드 (근태취소신청, 보상휴가취소신청일때만 전달)
    searchApplCd: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      emptyDataFlag: false, // 조회결과없음 플래그
      searchList: [],
      emptyDataText: messageConstants.emptyDataMsg_1,
    };
  },
  computed: {
    ...mapGetters('DIALOG', ['GET_DIALOG_CALLBACK']),
    stepChipClass() {
      return applStatusCd => {
        return {
          // 신청서상태코드 (21,31,98:결재처리중,수신처리중,승인요청중 / 23,33:결재반려,수신반려 / 99:처리완료)
          draft: applStatusCd == 23 || applStatusCd == 33,
          charge:
            applStatusCd == 21 || applStatusCd == 31 || applStatusCd == 98,
          approval: applStatusCd == 99,
        };
      };
    },
  },
  watch: {
    GET_DIALOG_CALLBACK(callback) {
      if (callback) {
        this.fetchMyBoxList();
      }
    },
  },
  methods: {
    /* 신청서뷰어 모달오픈 */
    async openViewer(appInfo) {

      // console.log('appInfo ::: ' + JSON.stringify(appInfo));
      /*
      if (appInfo.BApplSeq !== null) {
        alert('이미 취소신청건이 있어 취소신청을 할 수 없습니다');
        return;
      }
      */

      if (appInfo.cancleApplYn === 'N') {
        return;
      }

      if (appInfo.newApplCheck === 'N') {
        alert(
          '해당 근무일 신청 이후에 신청 완료된 동일한 근무일의 최신 데이터가 존재하여 취소 신청을 하실 수 없습니다.',
        );

        return;
      }

      appInfo.holReplaceCancelView = true;
      // console.log('appInfo ::: ' + JSON.stringify(appInfo));
      // console.log('openViewer :: ' + appInfo);
      this.$store.commit('SET_AUTHPG', 'R');
      this.$store.commit('DIALOG/SET_DIALOG_PARAM', appInfo);
      this.$store.commit('SET_APPL_SEQ', appInfo.applSeq);

      const param = { applSeq: appInfo.applSeq };
      const response = await getFileSeq(param);
      if (response.data.data !== null) {
        this.$store.commit('SET_FILE_SEQ', response.data.data.fileSeq);
      }

      this.$store.dispatch('ELA/FETCH_MENU_ACTION',  {
            applCd: appInfo.applCd
            , gntGubunCd: null
          }).then((result) => {
            /*
            this.$router.push({
              name : result
              , params : {
                applCd: appInfo.applCd
                , gntGubunCd: null
              }
            });
            */
          });

      this.$store.commit('DIALOG/TOGGLE_MODAL', 'application_viewer');

    },
    /* 내문서함 목록조회 */
    async fetchMyBoxList() {
      // 조회기준 :
      //  [내문서함] 신청일 기준 최근 한 달 && 모바일에서 사용하는 신청서 && 임시저장상태 제외
      //  [임시저장] 조회기간전체 && 모바일에서 사용하는 신청서 && 임시저장상태만
      //  [취소신청] 신청일 기준 최근 한 달 && 근태취소신청은 근태만, 보상휴가취소신청은 보상휴가만 && 처리완료상태만
      const paramObj = {
        searchReqGubun: this.searchReqGubun,
        searchApplCd: this.searchApplCd,
        searchSdate:
          this.searchReqGubun === 'TEMP'
            ? ''
            : dayjs().add(-1, 'month').format('YYYYMMDD'),
        searchEdate:
          this.searchReqGubun === 'TEMP' ? '' : dayjs().format('YYYYMMDD'),
      };

      try {
        const response = await holReplaceCancelBoxList(paramObj);
        console.dir(response);
        const dataList = response.data.data;

        if (dataList.length > 0) {
          this.searchList = dataList;
        }

        // 조회결과없음 플래그값 세팅
        this.emptyDataFlag = this.searchList.length < 1;

        this.$store.commit('SPINNER/OFF_COMMON_SPINNER'); // 공통 스피너 OFF
        this.$store.commit('DIALOG/SET_DIALOG_CALLBACK', false); // 모달 종료 콜백 OFF
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    // 공통 스피너 ON
    this.$store.commit('SPINNER/ON_COMMON_SPINNER');
    this.$store.commit('SET_PARAMS', []);
    //this.$store.commit('SET_FILE_SEQ', '');
    this.fetchMyBoxList();
  },
  components: {
    EmptyData,
    ApplMenuIcon,
  },
};
</script>

<style scope>
td {
  text-align: center;
}
</style>
